import React from "react";
import { IEscalation, IEscalationInfoRes } from "../../Models/applicationModels";
import { Box } from "@mui/material";
import styles from './escalationTable.module.css';
import { useInsightsUtils } from "../../hooks/useInsightsUtils";
import { useOutletContext } from "react-router-dom";
import Table, { ColumnsType } from "antd/es/table";
import { GetFormatTitle } from "../tableComponent/getTableColumn/getFormattedData";
import { formatUTCDateTime} from "../../utils/formatUTCDate";
import { APPLICATION_ESCALATION_UID_KEY } from "../CreateEscalation/createEscalation.constants";

interface EscalationTableProps {
    escalations: IEscalation[] | null;
    record: Record<string, any>;
};

type OutletContext = {
    availableEscalations: IEscalationInfoRes[];
}

const EscalationTable: React.FC<EscalationTableProps> = ({ escalations, record }) => {
    const { availableEscalations } = useOutletContext<OutletContext>();
    const { HandleAddEscalation, TransferEscalationData } = useInsightsUtils();
    const escalationNames = TransferEscalationData(availableEscalations);
    if (!escalations || escalations.length === 0) {
        return (
            <div className={`${styles.tableCtn} ${styles.noDataCtn}`}>
                No active escalations found
            </div>
        );
    }

    const onClickEscalation = (escalation: IEscalation) => {
        const id = escalationNames.find((e) => e.name === escalation.escalationType)?.id;
        if (!id) {
            return;
        }
        HandleAddEscalation({
            applicationEscalationUid: escalation.applicationEscalationUid,
            oppId: record.opportunityUid,
            escalationId: id,
            escalationName: escalation.escalationType,
            agencyName: record.tenantTitle,
        });
    }

    const columns: ColumnsType<IEscalation> = Object.keys(escalations[0]).filter((key) => key !== APPLICATION_ESCALATION_UID_KEY).map((key) => ({
        title: GetFormatTitle(key),
        dataIndex: key,
        key: key,
        render: (_: string, record: IEscalation) => {
            return renderTableCell(record, key);
        }
    }))

    const renderTableCell = (escalation: IEscalation, key: string) => {
        switch (key) {
            case "escalatedOn":
                return formatUTCDateTime(escalation[key as keyof IEscalation], false, true);
            case "escalationType":
                return <p className={styles.escalationType} onClick={() => onClickEscalation(escalation)}>
                    {escalation[key as keyof IEscalation]}
                </p>
            default:
                return String(escalation[key as keyof IEscalation]);
        }
    }

    return (
        <Box className={styles.tableCtn}>
            <Table<IEscalation> 
                columns={columns}
                dataSource={escalations}
                bordered
                pagination={false}
                rowKey={(_, index) => String(index)}
                rowClassName={(_, index) =>
                    index % 2 === 0 ? "ant-row-even" : "ant-row-odd"
                }
            />
        </Box>
    );
};

export default EscalationTable;